'use client';

import { closeCurrentModal } from '~/utils/mobileApp';

import { CloseIcon } from '~/assets/icons';

export function ModalCloseNavigation() {
  return (
    <div className="flex h-[60px] items-center justify-end px-20 py-16">
      <button type="button" onClick={() => closeCurrentModal()}>
        <CloseIcon className="size-24" />
      </button>
    </div>
  );
}
